import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5f42f1de"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "air-quality-status" }
const _hoisted_2 = { class: "air-title-time" }
const _hoisted_3 = { class: "air-title" }
const _hoisted_4 = { class: "air-time" }
const _hoisted_5 = { class: "weather" }
const _hoisted_6 = { class: "upper" }
const _hoisted_7 = {
  class: "iconfont icon-svg",
  "aria-hidden": "true"
}
const _hoisted_8 = ["xlink:href"]
const _hoisted_9 = { class: "temp" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tem-icon" }, "℃", -1))
const _hoisted_11 = { class: "text" }
const _hoisted_12 = { class: "lower" }
const _hoisted_13 = { class: "item" }
const _hoisted_14 = { class: "value" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description" }, "湿度", -1))
const _hoisted_16 = { class: "item" }
const _hoisted_17 = { class: "value" }
const _hoisted_18 = { class: "description" }
const _hoisted_19 = { class: "item" }
const _hoisted_20 = { class: "value" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description" }, "气压", -1))

import moment from 'moment';
import {
  computed,
} from 'vue';
import { useRouter, } from 'vue-router';
import { useStore, } from 'vuex';
import AirCard from './components/airCard/index.vue';
import { weatherRender, windDirection, } from '@/utils/index';
import { message, } from 'ant-design-vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter();
const store = useStore();
const locationData = computed(() => store.state.OLMap.location);
const frameData = computed(() => store.state.gateway.frameData);

/**
 * 空气质量详情查看
 * @returns {void}
 */
const handlerClick = () => {
  router.push('/index/airStatus');
};

// AQI产品数据,获取时间用
const productDatas = computed(() => store.state.gateway.productDatas);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(frameData).pointName ||
          _unref(locationData)?.location?.district ||
          _unref(locationData)?.location?.city || '南京市') + " 空气质量指数 ", 1),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(frameData).reportTime ?
          _unref(moment)(_unref(frameData).reportTime, 'YYYYMMDDHHmm').format('YYYY-MM-DD HH:mm'):
          Object.keys(_unref(productDatas)).length ? _unref(moment)(Object.keys(_unref(productDatas))[Object.keys(_unref(productDatas)).length - 1], 'YYYYMMDDHHmm').format('YYYY-MM-DD HH:mm') : '----'), 1)
    ]),
    _createVNode(AirCard),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(), _createElementBlock("svg", _hoisted_7, [
          _createElementVNode("use", {
            "xlink:href": `#icon-${_unref(weatherRender)(_unref(frameData).weather)}`
          }, null, 8, _hoisted_8)
        ])),
        _createElementVNode("span", _hoisted_9, [
          _createTextVNode(_toDisplayString(_unref(frameData).weatherVo?.tem && _unref(frameData).weatherVo?.tem !== '-9999' ? Number(_unref(frameData).weatherVo.tem).toFixed(0) : '-'), 1),
          _hoisted_10
        ]),
        _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(frameData).weatherAm !== _unref(frameData).weatherPm ? `${_unref(frameData).weatherAm || '-'}转${_unref(frameData).weatherPm || '-'}`: (_unref(frameData).weatherAm || '-')), 1)
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(frameData).weatherVo?.rhu && _unref(frameData).weatherVo?.rhu !== '-9999' ? Number(_unref(frameData).weatherVo.rhu).toFixed(1): '-') + "%", 1),
          _hoisted_15
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(frameData).weatherVo?.windS && _unref(frameData).weatherVo?.windS !== '-9999' ? Number(_unref(frameData).weatherVo.windS).toFixed(1) : '-') + "m/s", 1),
          _createElementVNode("div", _hoisted_18, _toDisplayString(_unref(frameData).weatherVo?.windD && _unref(frameData).weatherVo?.windD !== '-9999' ? _unref(windDirection)(Number(_unref(frameData).weatherVo.windD)) : '-'), 1)
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, _toDisplayString(_unref(frameData).weatherVo?.prs && _unref(frameData).weatherVo?.prs !== '-9999' ? Number(_unref(frameData).weatherVo.prs).toFixed(1) : '-') + "hPa", 1),
          _hoisted_21
        ])
      ])
    ]),
    _createElementVNode("div", {
      onClick: handlerClick,
      class: "btn-air-detail"
    }, "空气质量详情")
  ]))
}
}

})